const modalsClasses = {
  IS_OPEN: 'is-open',
  EXERCISE_MODAL_CARD: '.exercise-modal-card',
  RATING_MODAL_RATING_BLOCK: '.rating-modal-rating-block',
  RATING_MODAL_RATING: '.rating-modal-rating',
  RATING_MODAL_RATING_ICON: '.rating-modal-rating-icon',
  CLOSE_MODAL_BTN: '.close-modal-btn',
  ADD_TO_FAVORITES: '#add-to-favorites',
  GIVE_RATING: '#give-rating',
  REMOVE_FROM_FAVORITES: '#remove-from-favorites',
  RATING_MODAL_FORM: 'rating-modal-form',

  OPEN_EXERCISE_MODAL: '.card__start',
  EXERCISE_ITEM_FOR_DATA_ID: '.exercise-item',
};

export { modalsClasses };
